import { createSelector } from 'reselect';
import * as _ from 'lodash';
import { window } from '../../globals';
import type { ReduxStore } from '../store';
import { OrganizationSsoMethod } from '../../../typings/enums';
import type { Organization } from '../../types';
import type { OrganizationsStore } from '.';

const getOrganizationStore = (state: ReduxStore) => state.organizations;

export const getStatus = createSelector(getOrganizationStore, (organizations) => organizations.status);

// getCurrentOrganization returns the user's current organization (based on the user's organizationId).
export const getCurrentOrganization = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) =>
    (window.user?.organizationId && organizations.organizations[window.user.organizationId]) || null,
);
export const getCreatingAuditReportLoading = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.creatingAuditReportLoading,
);
export const getPendingOrgDomains = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.pendingOrgDomains,
);
export const getOrgDomains = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.orgDomains,
);
export const getHasSamlDomain = createSelector(
  getOrgDomains,
  (orgDomains) => orgDomains.domains.some(
    ({ ssoMethod }) => ssoMethod === OrganizationSsoMethod.SAML,
  ),
);
export const getSsoConfigurationStatus = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.ssoConfigurationStatus,
);
export const getCurrentJiras = createSelector(
  getCurrentOrganization,
  (organization: Organization) => organization?.jiras || [],
);
export const getOrganizationLabels = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.labels.labels,
);
export const getOrganizationLabelsStatus = createSelector(
  getOrganizationStore,
  (organizations: OrganizationsStore) => organizations.labels.status,
);
export const getSortedOrganizationLabels = createSelector(getOrganizationStore, (state: OrganizationsStore) =>
  _.sortBy(state.labels.labels, (label) => label.label.toLowerCase()),
);
